import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default data => {
  return {
    title: get(data, 'rcv2Headline', null),
    ranges: data.rcv2Ranges.map(item => {
      var range = item;
      return {
        id: get(item, 'range[0].id', null),
        title: get(item, 'range[0].title', null),
        series: get(item, 'series', []).map(item => {
          var hrefArr = get(item, 'link', null).split('/range/');
          var href = `/range/${hrefArr[1].split('?')[0]}`;
          var model = get(item, 'acf_series.seriesSpecsRep[0].seriesSpecRepFeaturedModel[0].acf_floor_plan', null);
          var img = get(model, 'modelExternalImagesRep[0].modelExternalImagesRepImage', null);
          var totalSleeps = parseInt(get(model,'modelSleepAdditionalStandard',0)) + parseInt(get(model,'modelSleepAdultStandard',0)) + parseInt(get(model,'modelSleepChildrenStandard',0));
          if (isNaN(totalSleeps)) {
            totalSleeps = 0;
          }
          var sleepingMax = parseInt(get(item, 'acf_series.sleepingMax', 0));
          if (isNaN(sleepingMax)) {
            sleepingMax = 0;
          }
          var sleeps = Math.max(totalSleeps, sleepingMax);
          sleeps = sleeps > 0 ? sleeps : '';
          return {
            id: get(item, 'id', null),
            title: get(item, 'title', null),
            href,
            subTitle: get(range, 'range[0].title', null),
            sleeps,
            models: [],
            compareValues: {
              rangeId: '',
              seriesId: '',
              spec: '',
              model: ''
            },
            image: img ? refactorRespImg(img, [{
              size: 'default',
              key: 'image_size_300x200',
            },{
              size: 'md',
              key: 'image_size_400x264',
            }]): null
          }
        }),
      }
    }),
    cta: {
      title: get(data, 'rcv2Cta.title', null),
      href: get(data, 'rcv2Cta.url', null),
      tagret: get(data, 'rcv2Cta.target', null),
      style: "primary",
      assignedDomains: [
        "jayco.com.au",
        "jayco.co.nz",
        "AU-dealers",
        "NZ-dealers"
      ]
    }
  }
}
